<template>
	<article :id="id" class="dc-post-grid-card webinar-card"
		v-on:click.meta.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.ctrl.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.exact.stop.prevent="goToPost('click')">
		<div
			:class="[
				'card-image',
				{
					'no-image': !image,
				},
			]"
		>
			<img v-if="image" :src="image.src" :srcset="image.srcset" :alt="image.alt" />
		</div>
		<div ref="cardContentWrapper" class="card-content">
			<h3 v-if="title" class="card-title">{{ title }}</h3>
			<p v-if="excerpt" class="card-excerpt">{{ excerpt }}</p>
			<dc-button :url="url" :aria-label="`Read article: ${title}`" />
		</div>
	</article>
</template>

<script>
import Post from './Post';
export default {
	extends: Post,
};
</script>
